import {
  GET_MILESTONE_STATUS_LIST,
  LOADING_MILESTONE_STATUS_LIST
} from "../../../actions/core/invoice/milestone_status";

const initialState = {};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_MILESTONE_STATUS_LIST:
      return {
        ...state,
        loading: true
      };
    case GET_MILESTONE_STATUS_LIST:
      return {
        ...state,
        loading: false,
        status: action.status.data
      };
    default:
      return state;
  }
};
